var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"https://storage.lemonstea.com/wechat-resource/lemonstea_report_demo_0729.png","alt":""}})])}]

export { render, staticRenderFns }